import { UserRole } from '@/enums/UserRole';
import { authState } from '@/services/integrations/auth0';
import { computed } from 'vue';
import { getPermission, PermissionType } from '@/services/config';

export const canToggleFeatures = computed(() => {
  const userRoles = authState.userRoles.value;
  return userRoles.includes(UserRole.PHAROS_LABS_FEATURE_FLAG);
});

export const canCreateProspects = computed(() => {
  return getPermission(PermissionType.CAN_CREATE_PROSPECTS);
});

export const canCreateScenarios = computed(() => {
  const userRoles = authState.userRoles.value;
  return (
    userRoles.includes(UserRole.BANKER_ASSISTANT) ||
    userRoles.includes(UserRole.TEAM_HEAD) ||
    userRoles.includes(UserRole.MARKET_HEAD) ||
    userRoles.includes(UserRole.BANKER)
  );
});

export const canAlwaysCreateScenarios = computed(() => {
  const userRoles = authState.userRoles.value;
  return (
    userRoles.includes(UserRole.BANKER_ASSISTANT) ||
    userRoles.includes(UserRole.TEAM_HEAD)
  );
});

export const canInitiateReviews = computed(() => {
  const userRoles = authState.userRoles.value;
  return (
    userRoles.includes(UserRole.SENIOR_MANAGER) ||
    userRoles.includes(UserRole.MARKET_HEAD) ||
    userRoles.includes(UserRole.TEAM_HEAD)
  );
});

export const canViewAllTasks = computed(() => {
  const userRoles = authState.userRoles.value;
  return userRoles.includes(UserRole.TASK_APPROVER);
});

export const canViewOpportunities = computed(() => {
  const userRoles = authState.userRoles.value;
  return (
    userRoles.includes(UserRole.BANKER) ||
    userRoles.includes(UserRole.TEAM_HEAD) ||
    userRoles.includes(UserRole.MARKET_HEAD)
  );
});
